export default "__VITE_ASSET__6nVI35il__"